"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationApiTest = exports.isStringOrNullType = exports.INTEGRATION_TEST_LOCATION_API_URL = void 0;
var tslib_1 = require("tslib");
var argvLocationApiUrl = global.argv ? global.argv.locationApiUrl : '';
exports.INTEGRATION_TEST_LOCATION_API_URL = argvLocationApiUrl || 'https://webexintegrationblue.2ea261f1307d4469934a.northeurope.aksapp.io';
var isStringOrNullType = function (s) { return s === null || typeof s == 'string'; };
exports.isStringOrNullType = isStringOrNullType;
var LocationApiTest = /** @class */ (function () {
    function LocationApiTest() {
    }
    LocationApiTest.checkStringParameter = function (paramName, paramValue) {
        it(paramName + " must be present in params", function () {
            global.expect(paramValue).to.exist;
            global.expect(paramValue).not.empty;
        });
    };
    LocationApiTest.checkCountryCode = function (countryCode) {
        this.checkStringParameter('countryCode', countryCode);
    };
    LocationApiTest.checkLanguageCode = function (languageCode) {
        this.checkStringParameter('languageCode', languageCode);
    };
    LocationApiTest.checkIfErrorsAreNotThrown = function (loadCountriesApiPromise) {
        var _this = this;
        describe('--- Check if promise does not throw errors ---', function () {
            it('should not throw errors', function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, global.expect(loadCountriesApiPromise).not.to.be
                                .rejected];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    return LocationApiTest;
}());
exports.LocationApiTest = LocationApiTest;
